export default class Offer {

  constructor(data) {

    this.group_ids = ['a'];
    Object.assign(this, data);

    // console.log('this', this);
    // if (this.action === 'sell') {
    //   this.currency = currencySigns[this.currency];
    // } else {
    //   this.price = null;
    //   this.currency = null;
    // }

  }

  getPricePretty() {
    const currencySigns = {
      'ILS': '₪',
      'USD': '$',
      'EUR': '€',
      'GBP': '£'
    };

    // console.log(this.currency);

    if (this.action === 'sell' && this.price) {
      return `${this.price}${currencySigns[this.currency]}`;
    } else {
      return '';
    }

  }

  getActionPretty() {
    if (this.action === "review") {
      return "review_offer";
    } else if (this.action === "give") {
      // return this.give_as;
      return "give";
      // }else if(this.action === "give" && this.give_as === "give_as_gift"){
      // return "free";
    } else if (this.action === "find") {
      return "want";
    } else if (this.action === "rent") {
      return "rent";
    } else if (this.action === "sell" && (this.fee_for && this.fee_for.includes("_rent"))) {
      return "rent";
    } else {
      if (this.action === "sell" && (!this.fee_for || this.fee_for.includes("_buy"))) {
        return null;
      } else {
        return this.action;
      }
    }
  }

  getActionPretty2() {
    if (this.action === "give") {
      return 'get_button';
      // }else if(this.action === "give" && this.give_as === "give_as_gift"){
      // return "free";
    } else if (this.action === "sell" && this.fee_for.includes("_rent")) {
      return "rent_button";
    } else
    if (this.action === "sell" && this.fee_for.includes("_buy")) {
      return "buy_button";
    } else {
      return this.action;
    }
  }

  getActionForShowResource() {
    if (this.action === "review") {
      return "review_offer";
    } else if (this.action === "give") {
      // 
      // }else 
      // debugger
      if (this.action === "give" && this.give_as === "give_as_gift") {
        return "give";
      }
      return this.give_as;
      // return "free";
    } else if (this.action === "find") {
      return "want";
    } else if (this.action === "sell" && this.fee_for.includes("_rent")) {
      return "rent";
    } else
    if (this.action === "sell" && this.fee_for.includes("_buy")) {
      return null;
    } else {
      return this.action;
    }
  }


  // getGroupNameslist() {
  //   let list = [];
  //   const ungrouped = this.privacy_groups.find(pg => pg.id === 'ungrouped');
  //   list = list.concat(this.privacy_groups.filter(pg => pg !== 'ungrouped').map(pg => pg.name));
  //   if (ungrouped && ungrouped.contacts.length) {
  //     list = list.concat(ungrouped.map(pg => pg.name));
  //   }
  //   return list.join(', ');
  // }
}
